import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ns7v1vn8m: FaireBrandEntity = {
  token: "b_9ns7v1vn8m",
  type: "brand",
  name: "TBF",
  avatarUrl:
    "https://cdn.faire.com/fastly/5150e8b4a0b10b357eb5f06829836cce9d0faa3d36ad8b648e000775a0bcb6d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6d0b80d186cced2951a6807abb8339676bb2920593f441f17f60083c3ed01598.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5150e8b4a0b10b357eb5f06829836cce9d0faa3d36ad8b648e000775a0bcb6d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6d0b80d186cced2951a6807abb8339676bb2920593f441f17f60083c3ed01598.jpeg",
  location: "Garden Grove, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 200,
  isTopShop: true,
  isInsider: true,
  description:
    "TBF is the largest online source of wholesale tote bags, canvas bags, drawstring backpacks, and many more! We are conveniently located in Southern California and we do offer fast and affordable delivery to all continental US.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:07.360Z",
    importedBy: "entity-db-cli",
  },
};
